import type {ReactNode, Ref} from 'react'
import {clsx} from 'clsx'
import styles from './CommentLayout.module.css'

interface CommentLayoutProps {
  header: ReactNode
  children: ReactNode
  id?: string
  ref?: Ref<HTMLElement>
  className?: string
  tabIndex?: number
  flushBody?: boolean
}

export function CommentLayout({header, children, className, flushBody, ...props}: CommentLayoutProps) {
  return (
    <article className={clsx(styles.container, className)} {...props}>
      <div className={styles.header}>{header}</div>
      {!!children && <div className={clsx(styles.body, flushBody && styles.flushBody)}>{children}</div>}
    </article>
  )
}
